<h2 mat-dialog-title>Choose a file</h2>
<mat-dialog-content>
    <app-attachment-browser (change)="onChange($event)" [pickerMode]="!multiple" [MultiPathes]="[{path: '/', virtualFolder: 'Storage'}]"></app-attachment-browser>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="fill-remaining-space"></div>
    <button type="button" mat-raised-button mat-dialog-close>Close</button>
    <button type="button" mat-raised-button [disabled]="!file && files.length === 0" (click)="pick()" color="primary">Select</button>
</mat-dialog-actions>
